export default "__VITE_ASSET__D44kEn7B__"